import { Radio, styled } from "@mui/material";

export const CustomRadio = styled(Radio)({
    '&.Mui-checked': {
        color: '#034D78'
      },
})